const images: any = {};
const handleOnLoad = ({ target: { src: _src } }: any) => {
  if (images[_src]) return;
  images[_src] = true;
  console.log("图片加载成功:", _src);
};
const handleOnError = ({ target: { src: _src } }: any) => {
  if (images[_src]) return;
  images[_src] = true;
  console.log("图片加载失败:", _src);
};
export const WeatherImage: React.FC<any> = ({ src, prefix = true, ...args }: any) => {
  const url = prefix ? import.meta.env.VITE_API_ATRGET + src : src;
  return src && <img src={url} alt={url} {...args} onLoad={handleOnLoad} onError={handleOnError} />;
};
